
import { defineComponent } from 'vue';
import { mapState } from 'pinia'

// Helpers
import { usePartnerConfigHelper } from '@white-label-helper/shared-helpers';
import { BOOKING_STATUSES } from '@white-label-configuration/constants';

// Store
import { useManageBookingStore } from '@white-label-store/manage-booking';

// Components
import Button from '../button/button.vue';

type BookingStatus = typeof BOOKING_STATUSES[keyof typeof BOOKING_STATUSES];

export default defineComponent({
  name: 'ManageBookingCancelButtons',

  components: {
    ControlButton: Button,
  },

  props: {
    isLoading: {
      type: Boolean,
    },
    disableCancel: {
      type: Boolean,
    },
  },

  computed: {
    ...mapState(useManageBookingStore,['readBookingStatus']),
    orderStatus(): BookingStatus {
      return this.readBookingStatus;
    },

    crossSellOrMultiBasketEnabled() {
      const { isCrossSellFlowEnabled, isMultiBasketEnabled } = usePartnerConfigHelper();
      return isCrossSellFlowEnabled || isMultiBasketEnabled;
    },

    /**
     * Disable cancel button if:
     * - cancel button is disabled by external prop
     * - or cross sell and multibasket are off (i.e there can only be one item in order)
     * - AND overall order status is not CONFIRMED
     *
     * This means that for multi-item orders where the overall status may be IN_PROGRESS,
     * the user can still cancel a cancellable item.
     */
    isButtonDisabled(): boolean {
      return this.disableCancel ||
        (
          !this.crossSellOrMultiBasketEnabled &&
          this.orderStatus !== BOOKING_STATUSES.CONFIRMED
        );
    },
  },

  methods: {
    cancelBookingHandler(): void {
      this.$emit('cancel-booking');
    },

    keepBookingHandler(): void {
      this.$emit('keep-booking');
    },
  },
});
